import { ADMIN_BETA_FEATURES, ADMIN_NEW_FEATURES, CREATE_CONTENT } from '@confluence/named-routes';
import { useIsProductAdmin } from '@confluence/current-user';
import { useRouteName } from '@confluence/route-manager';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage';
import { useSkippableCoordination } from '@confluence/skippable-coordination-client';

const disableOnboardingRouteNames = [
	ADMIN_BETA_FEATURES.name,
	ADMIN_NEW_FEATURES.name,
	CREATE_CONTENT.name,
];
const isOnDisabledOnboardingRouteArgs = {
	selector: (routeName: string | undefined) => {
		if (!routeName) {
			return true;
		}
		return disableOnboardingRouteNames.includes(routeName);
	},
};

type UseNewFeatureAdminOnboardingCoordinationProps = {
	isOnboardingEnabled: boolean;
	messageId: string;
};
export const useNewFeatureAdminOnboardingCoordination = ({
	isOnboardingEnabled,
	messageId,
}: UseNewFeatureAdminOnboardingCoordinationProps) => {
	const { isProductAdmin } = useIsProductAdmin();
	const isOnDisabledOnboardingRoute = useRouteName(isOnDisabledOnboardingRouteArgs);

	const isEditorPage = useIsEditorPage();

	const showOptInModal =
		isOnboardingEnabled && isProductAdmin && !isOnDisabledOnboardingRoute && !isEditorPage;

	return useSkippableCoordination(messageId, !showOptInModal);
};
